var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiverseNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0859 8.28874H19.8359L17.4609 5.12207L15.0859 8.28874ZM15.0859 11.4554H19.8359L17.4609 14.6221L15.0859 11.4554Z",
    fill: "#2E3192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6276 0.37207H6.3776V19.3721H1.6276C1.41764 19.3721 1.21628 19.2887 1.06781 19.1402C0.919344 18.9917 0.835938 18.7904 0.835938 18.5804V1.16374C0.835938 0.953774 0.919344 0.75241 1.06781 0.603944C1.21628 0.455477 1.41764 0.37207 1.6276 0.37207Z",
    fill: "#2E3192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 0.37207H12.7109C12.9209 0.37207 13.1223 0.455477 13.2707 0.603944C13.4192 0.75241 13.5026 0.953774 13.5026 1.16374V18.5804C13.5026 18.7904 13.4192 18.9917 13.2707 19.1402C13.1223 19.2887 12.9209 19.3721 12.7109 19.3721H7.96094V0.37207Z",
    fill: "#2E3192"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0.835938 0.37207)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiverseNetwork);
export default __webpack_public_path__ + "static/media/diverseNetwork.01c4edcc913c9bcc51f359e3de371554.svg";
export { ForwardRef as ReactComponent };